import { Grid } from '@mui/material';
import { Dropdown } from '../../../../../../../ui/components/pure/dropdown/dropdown.component';
import { useBookOrderActionContext } from '../../book-order-action.context';
import { SectionTitle } from '../section-title/section-title.component';

export function AllStepsLeftSide({ disableProjectSelector }: { disableProjectSelector?: true }) {
  const { state, handlers, retailerOptions } = useBookOrderActionContext();
  return (
    <Grid
      container
      sx={{ flexDirection: 'column' }}
      spacing={3}
      style={{ padding: '8px 12px', width: '100%', margin: 0 }}
    >
      <Grid>
        <SectionTitle value="Retailer" />
      </Grid>
      <Grid>
        <Dropdown
          onChange={(event) => handlers.onSelectProject(event.target.value)}
          value={state.projectID}
          fullWidth
          textFieldDesktopWidth="100%"
          dropdownVariant="floating"
          menuItems={retailerOptions}
          shrinkLabel={false}
          placeholder="Retailer"
          disabled={disableProjectSelector}
        />
      </Grid>
    </Grid>
  );
}
